import styled from "styled-components";

const RawProductsPageStyled = styled.div`

`;

export default RawProductsPageStyled;